import { render, staticRenderFns } from "./certificateView.vue?vue&type=template&id=02525aa6&scoped=true"
import script from "./certificateView.vue?vue&type=script&lang=js"
export * from "./certificateView.vue?vue&type=script&lang=js"
import style0 from "./certificateView.vue?vue&type=style&index=0&id=02525aa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02525aa6",
  null
  
)

export default component.exports